<div class="alert alert-secondary" *ngIf="form.working">
	{{ workingMessage }}
</div>
<div class="alert alert-warning" *ngIf="form.error">
	{{ form.error }}
</div>
<div class="alert alert-success" *ngIf="form.success">
	{{ form.success }}
</div>
